import request from "@/utils/request"

export function unReadNum() {
  return request.post("/mesContent/unReadNum")
}

export function list(pageNum = 1, pageSize = 10) {
  return request.post("/mesContent/list", { pageNum, pageSize })
}

export function read(id) {
  return request.post("/mesContent/edit", { id: id, readStatus: 1 })
}
